import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/teacher-education-levels/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const teacherEducationLevel = {
  getAll: apiPathFunc(pathBase),
} as const;
